// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3f_Xl_BT6N_rWncBRZdr2y","headerImage":"_1LyqzOJOWt5Trtnp_o2zPV","subHeadline":"_1NX1fBr-78Bv9ln7PHTZoa","description":"GbxswbZW9bRBT3DksTN0g"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SubHeader/subheader.less
// module id = 218
// module chunks = 0